import axios from 'axios';

const api = axios.create({
  // URL del API definida por entorno (archivos .env / .env.development /
  // .env.production). En desarrollo es relativa ('/api/') y pasa por el proxy
  // del dev-server; en producción es la URL absoluta de .env.production.
  baseURL: process.env.VUE_APP_API_URL || '/api/', // base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para enviar token automáticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Bearer token
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: si el token expiró o es inválido (401),
// limpia la sesión y regresa al login (evitando bucle si ya está ahí).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// 🔹 Función para obtener permisos de un módulo
export const obtenerPermisosPorModulo = async (modulo) => {
  if (!modulo) return {}; // Evita enviar vacío
  try {
    const res = await api.post('permisos/modulo', { modulo });
    return res.data.permisos || {}; // devuelve los permisos o un objeto vacío
  } catch (error) {
    console.error('Error al obtener permisos:', error.response?.data?.message || error.message);
    return {};
  }


  
};


export default api;
